<template>
  <b-col md="12" xl="6">
    <section class="hotel">
      <div class="hotel__head">
        <div class="hotel__element">
          <div class="hotel__item">
            <b-form-rating
              class="hotel__star"
              v-if="selected_property.ratings.property"
              no-border inline readonly
              size="sm"
              variant="secondary"
              :value="selected_property.ratings.property.rating"
            />
          </div>
          <div class="hotel__item">
            <p class="hotel__name" v-html="selected_property.name" />
          </div>
          <div class="hotel__item">
            <vb-icon class="hotel__icon hotel__icon--geo mr-1" :name="'pin'" :color="sass('primary')" :size="13" />
            <span>
              {{ selected_property.location.address}},
              {{ selected_property.location.zip }} {{ selected_property.location.city }}
            </span>
          </div>
        </div>
        <div class="hotel__element">
          <score class="hotel__score" :rating="selected_property.ratings.salabam_score" />
        </div>
      </div>
      <ul class="hotel__amenities" v-if="solution.property.room">
        <template v-for="(amenity, amenity_index) in Object.values(solution.property.room.amenities)">
          <li class="hotel__amenities-li" v-if="amenity_index < 6" :key="_uid + '_amenity_' + amenity_index">
            <amenity :item="amenity" :type="'rooms'" />
          </li>
        </template>
      </ul>
    </section>
  </b-col>
</template>

<script>
import { mapState } from 'vuex'
import Score from "@liveeps/components/atoms/score"
import Amenity from "@liveeps/components/atoms/amenity"

export default {
  inheritAttrs: false,
  name: 'hotel',

  components: {
    'amenity': Amenity,
    'score': Score,
  },

  props: {
    solution: Object,
  },

  data() {
    return {
    }
  },

  computed: {
    ...mapState({
      // stato del modulo liveeps
      selected_property: state => state.liveeps.selected_property,
    }),
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .hotel {
    background-color: $white;
    border-radius: $border-radius-lg * 2;
    padding: $grid-gutter-20;
    height: 100%;

    @media print {
      padding: 0;
      margin-bottom: $grid-gutter-width;
    }

    &__head {
      display: flex;
    }

    &__element {
      &:first-child {
        flex-basis: 100%;
      }
    }

    &__item {
      display: flex;
      align-items: center;
    }

    &__star {
      width: auto;
      margin-bottom: $grid-gutter-width / 6;
    }

    &__name {
      font-weight: $vb-font-weight-semibold;
      font-size: $font-size-lg;
      margin-bottom: 0;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 350px;
    }

    &__amenities {
      border-top: 1px solid $gray-200;
      margin-top: $grid-gutter-width/2;
      margin-bottom: 0;
      padding: $grid-gutter-width / 2 0 0;
      list-style: none;
      display: flex;
      flex-wrap: wrap;

      &-li {
        display: flex;
        align-items: center;
        font-size: $font-size-md;
        line-height: normal;
        padding: 2px $grid-gutter-width / 2 2px 0;
      }
    }

    &__score {
      font-size: $font-size-md;

      ::v-deep {
        .score__number {
          span {
            $size: $grid-gutter-width;
            width: $size;
            height: $size;
          }
        }
      }
    }
  }

</style>